import React, { FC, memo, useState } from 'react';
import { ArrowsAltOutlined, ShrinkOutlined } from '@ant-design/icons';
import { WaybillTrackLogResponse } from '@/services/type';
import { useParams, useHistory } from 'react-router-dom';
import { waybillStatusOptions } from '@/utils/constant';
import { Button } from 'antd';

interface Props {
  data?: WaybillTrackLogResponse;
}
const Index: FC<Props> = ({ data: detail }) => {
  const history = useHistory();
  const { id } = useParams<{ id: string }>();
  const [expanded, setExpanded] = useState(false);

  return (
    <div className='absolute top-2 right-2 w-[280px] bg-white rounded-lg shadow-lg z-10 overflow-hidden'>
      <div className='flex justify-between items-center p-4 border-b border-gray-100'>
        <div className='font-bold text-gray-800'>最新物流信息</div>
        {detail?.routeInfoList?.length === 1 ? null : expanded ? (
          <ShrinkOutlined className='text-gray-400 cursor-pointer' onClick={() => setExpanded(false)} />
        ) : (
          <ArrowsAltOutlined className='text-gray-400 cursor-pointer' onClick={() => setExpanded(true)} />
        )}
      </div>
      <div className='p-4 max-h-[calc(100vh-200px)] overflow-y-auto'>
        {(expanded ? detail?.routeInfoList : detail?.routeInfoList?.slice(0, 1))?.map((item, index) => (
          <div key={index} className='relative pl-4 pb-6 last:pb-0'>
            {index !== (detail?.routeInfoList?.length ?? 0) - 1 && (
              <div className='absolute left-[5px] top-2 bottom-0 w-0 border-l border-dashed border-gray-300' />
            )}
            <div
              className={`absolute left-0 top-1 w-[10px] h-[10px] rounded-full border-2 ${index === 0 ? 'border-orange-500 bg-white' : 'border-gray-400 bg-white'}`}
            >
              {index === 0 && (
                <div className='w-[4px] h-[4px] rounded-full bg-orange-500 absolute top-[1px] left-[1px]' />
              )}
            </div>
            <div>
              <div className={`font-bold mb-1 ${index === 0 ? 'text-gray-900' : 'text-gray-500'}`}>
                {waybillStatusOptions.find((_) => _.value === item.waybillStatus)?.label}
              </div>
              <div className='text-xs text-gray-400 mb-1'>{item.createTime}</div>
              <div className='text-xs text-gray-500'>{item.routeInfo}</div>
            </div>
          </div>
        ))}
      </div>
      <div className='p-4 border-t border-gray-100'>
        <Button
          type='primary'
          block
          className='bg-[#ff7d00] hover:!bg-[#ff9d33] border-none h-10 text-base'
          onClick={() => history.push(`/order/city/bol/${detail?.orderDetail?.id}?orderNo=${id}`)}
        >
          查看BOL
        </Button>
      </div>
    </div>
  );
};

export default memo(Index);
